import React from 'react';
import { AlertTriangle } from 'lucide-react';
import './InvestmentDisclaimer.css';

const InvestmentDisclaimer = () => {
  return (
    <div className="investment-disclaimer rounded-2xl p-4 mb-4">
      <div className="flex items-center gap-1 mb-1">
        <AlertTriangle size={16} className="investment-disclaimer-icon flex-shrink-0" />
        <h3 className="investment-disclaimer-title text-sm font-bold">투자 유의사항</h3>
      </div>
      <p className="investment-disclaimer-text text-sm leading-relaxed">
        본 서비스의 정보는 참고용이며 투자 권유가 아닙니다. 모든 투자 결정과 손실 책임은 투자자 본인에게 있습니다.
        <p>현재 AI 모델 고도화 작업 중에 있습니다. 점수가 하루에 여러번 업데이트 될 수 있으니 참고 바랍니다.</p>
        {/* 과거 수익률은 미래를 보장하지 않으며, 투자 전 충분한 검토를 권장합니다. */}
      </p>
    </div>
  );
};

export default InvestmentDisclaimer;